var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38086 11.9981L10.7909 14.4181L15.6209 9.57812",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7509 2.45031C11.4409 1.86031 12.5709 1.86031 13.2709 2.45031L14.8509 3.81031C15.1509 4.07031 15.7109 4.28031 16.1109 4.28031H17.8109C18.8709 4.28031 19.7409 5.15031 19.7409 6.21031V7.91031C19.7409 8.30031 19.9509 8.87031 20.2109 9.17031L21.5709 10.7503C22.1609 11.4403 22.1609 12.5703 21.5709 13.2703L20.2109 14.8503C19.9509 15.1503 19.7409 15.7103 19.7409 16.1103V17.8103C19.7409 18.8703 18.8709 19.7403 17.8109 19.7403H16.1109C15.7209 19.7403 15.1509 19.9503 14.8509 20.2103L13.2709 21.5703C12.5809 22.1603 11.4509 22.1603 10.7509 21.5703L9.17086 20.2103C8.87086 19.9503 8.31086 19.7403 7.91086 19.7403H6.18086C5.12086 19.7403 4.25086 18.8703 4.25086 17.8103V16.1003C4.25086 15.7103 4.04086 15.1503 3.79086 14.8503L2.44086 13.2603C1.86086 12.5703 1.86086 11.4503 2.44086 10.7603L3.79086 9.17031C4.04086 8.87031 4.25086 8.31031 4.25086 7.92031V6.20031C4.25086 5.14031 5.12086 4.27031 6.18086 4.27031H7.91086C8.30086 4.27031 8.87086 4.06031 9.17086 3.80031L10.7509 2.45031Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDVerify);
export default __webpack_public_path__ + "static/media/d_verify.8b478b9958119cc13b483fc4c950c494.svg";
export { ForwardRef as ReactComponent };